"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderSearchResult = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const components_1 = require("./components");
const hooks_1 = require("./hooks");
const SearchResult = React.memo(({ tabsConfig, configData, dictionary }) => {
    const configState = (0, hooks_1.useSearchResultConfig)(tabsConfig, configData, dictionary);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${configState.isZeroResult ? '' : 'min-h-[calc(100vh-var(--header-height))]'}`, children: [(0, jsx_runtime_1.jsx)(components_1.SearchResultZeroResult, { isZeroResult: configState.isZeroResult, zeroResultMessage: configData.zeroResultMessage }), (0, jsx_runtime_1.jsx)(components_1.SearchResultHeader, { label: dictionary.searchResultsFor, configState: configState }), (0, jsx_runtime_1.jsx)(components_1.ContentContainer, { configState: configState, configData: configData })] }));
});
const RenderSearchResult = (element, props) => {
    const { tabsConfig, configData, dictionary } = props;
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(SearchResult, { tabsConfig: tabsConfig, configData: configData, dictionary: dictionary }), element);
};
exports.RenderSearchResult = RenderSearchResult;
